import { IsInt, Min, Max, IsOptional, IsNumber } from "class-validator";
import { IAdapterCalendarShift } from "./adapter-calendar-shift.interface";
import { IsCalendarShiftRequired } from "./validators";

export class AdapterCalendarShift implements IAdapterCalendarShift {
  @IsOptional()
  shift_id?: string | null;

  @IsCalendarShiftRequired()
  shift: string;

  @IsOptional()
  duration_hours: number;

  @IsOptional()
  @IsInt()
  @Min(0)
  @Max(23)
  start_hours: number;

  @IsOptional()
  @IsInt()
  @Min(0)
  @Max(59)
  start_minutes: number;

  @IsOptional()
  @IsInt()
  @Min(0)
  @Max(23)
  end_hours: number;

  @IsOptional()
  @IsInt()
  @Min(0)
  @Max(59)
  end_minutes: number;

  @IsOptional()
  @IsNumber()
  available_hours?: number;
}
